module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-inputtool-emoji"
  }, [_c('div', {
    staticClass: "kiwi-inputtool-emoji-palette",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
      },
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, _vm._l((_vm.emojis), function(text, eCode) {
    return _c('div', {
      staticClass: "kiwi-inputtool-emoji-emoji",
      style: ({
        'background-image': ("url(" + _vm.location + eCode + ".png)")
      }),
      attrs: {
        "data-code": text + ' '
      },
      on: {
        "click": _vm.onImgClick
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bed3513!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputtools/Emoji.vue
// module id = 487
// module chunks = 2